import { MapTo } from '@adobe/aem-react-editable-components';
import SignUp, { SignUpEditConfig } from './SignUp';

export default MapTo('cob-corp-acquisition/components/creditonebank/sign-up')(SignUp, SignUpEditConfig);